import React, { useState, useMemo, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Rate,
  Row,
  Col,
  Typography,
  Modal,
  Drawer,
  Input,
  message,
} from "antd";
import moment from "moment";
import { RestaurantRate } from "./Rate";
import { slimImage } from "@/service/utils";
import { RightOutlined } from "@ant-design/icons";
import { Icon, Header, Button, Gallery, WriteReview } from "@/components";
import { useStores } from "@/store";
import { getQuery } from "@/service/http";
function padRight(str) {
  return Number(str).toFixed(1);
}
let setLiking = false;
/**评分&评论 */
export const Reviews = ({ restaurant, setRestaurant }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [list, setList] = useState([]);
  const [currentReview, setCurrentReview] = useState({});
  const [page, setPage] = useState(1);
  const [showMore, setShowMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [reviewVisible, setReviewVisible] = useState(false);
  const [openReply, setOpenReply] = useState(false);
  const [successVisible, setSuccessVisible] = useState({
    visible: false,
    tip: "",
  });
  const { restaurantStore, reviewStore } = useStores();
  let submiting = false;

  useEffect(() => {
    setPage(1);
    onLoadMore(1);
  }, [restaurant]);

  useEffect(() => {
    if (page > 1) {
      onLoadMore(20);
    }
  }, [page]);

  const count = useMemo(() => {
    return restaurant.reviews_count;
  }, [restaurant]);

  const first = useMemo(() => {
    return list[0] || null;
  }, [list]);

  /**加载更多 */
  async function onLoadMore(per_page) {
    setLoading(true);
    let data = await restaurantStore.getReviews(page, null, per_page);
    let newList = [];
    if (page > 1) {
      newList = list.concat(data);
    } else {
      newList = data;
    }

    setShowMore(newList.length < count);
    setLoading(false);
    setList(newList);
  }

  /**查看详情 */
  function onShow(item) {
    setCurrentReview(item);
    setVisible2(true);
  }

  /**查看大图 */
  function onPreview() {}

  async function viewAll() {
    onLoadMore(20);
    setVisible(true);
  }
  async function showMoreReviews() {
    setPage(page + 1);
    onLoadMore(20);
    setVisible(true);
  }
  // 删除评论
  function onDelete(id) {
    let newList = list.filter((item) => item.id !== id);
    setList(newList);
    setVisible(false);
  }

  // 回复评论
  function onReply(item) {
    setOpenReply(true);
    setCurrentReview(item);
    setVisible2(true);
  }

  // 编辑并打开评论
  function onEdit(review) {
    setCurrentReview(review);
    setReviewVisible(true);
  }

  // 编辑评论
  const onSubmitReview = (type, rid, options, sid = "") => {
    if (submiting) return;
    submiting = true;
    reviewStore
      .submitEditReview(type, rid, sid, options)
      .then((res) => {
        if (res && res.status) {
          let _reviews = [...list];
          let listIndex = _reviews.findIndex((item) => item.id === sid);
          if (listIndex >= 0) {
            res.review.timestamp = new Date().getTime();
            res.review.liked = _reviews[listIndex].liked;
            _reviews.splice(listIndex, 1, res.review);
            setList(_reviews);
            setCurrentReview(res.review);
          }
          reviewStore.deleteDraft(restaurant.id);
          reviewStore.reviewInit();
          message.success(t("REVIEW.Saved Successfully"));
          setReviewVisible(false);
        }
      })
      .finally(() => {
        submiting = false;
      });
  };

  return (
    <section className="page-restaurant--reviews" hidden={count == 0}>
      <h3>{t("WEB.Reviews", { count: count })}</h3>
      <RestaurantRate restaurant={restaurant} />
      {first ? (
        <ReviewItem
          review={first}
          reviews={list}
          setReviews={setList}
          setCurrentReview={setCurrentReview}
          onPreview={onPreview}
          onDelete={onDelete}
          onEdit={onEdit}
          onClick={() => viewAll()}
          onReply={onReply}
        />
      ) : null}
      <div
        className="hairline-bottom"
        style={{ height: 10, marginBottom: 10, marginTop: -10 }}
      ></div>
      <footer className="view-all flex" onClick={() => viewAll()}>
        <span>{t("WEB.View all")}</span>
        <RightOutlined />
      </footer>

      {/* 详情 */}
      <ReviewDetail
        review={currentReview}
        setCurrentReview={setCurrentReview}
        onPreview={onPreview}
        visible={visible2}
        setVisible={setVisible2}
        onEdit={onEdit}
        onDelete={onDelete}
        reviews={list}
        setReviews={setList}
        openReply={openReply}
      />

      {/* 列表 */}
      <Drawer
        className="restaurant-drawer reviews-drawer"
        data-left={visible2}
        placement="right"
        closable={false}
        destroyOnClose
        onClose={() => setVisible(false)}
        visible={visible}
      >
        <Header
          title={t("WEB.ReviewsTitle")}
          onClick={() => setVisible(false)}
        />
        <h3>{t("WEB.Reviews", { count: restaurant.reviews_count })}</h3>
        <div style={{ marginBottom: 10 }}>
          <RestaurantRate restaurant={restaurant} />
        </div>
        {list.map((item) => {
          return (
            <ReviewItem
              key={item.id}
              review={item}
              reviews={list}
              setReviews={setList}
              setCurrentReview={setCurrentReview}
              mobile={true}
              onPreview={onPreview}
              onDelete={onDelete}
              onEdit={onEdit}
              onReply={() => onReply(item)}
              onClick={() => onShow(item)}
            />
          );
        })}
        <div className="show-load">
          {showMore && (
            <Button
              type="primary"
              block
              onClick={() => showMoreReviews()}
              loading={loading}
            >
              {t("WEB.Show more reviews")}
            </Button>
          )}
        </div>
      </Drawer>

      {/* 评论 */}
      <WriteReview
        visible={reviewVisible}
        restaurant={restaurant}
        editReview={currentReview}
        successVisible={successVisible}
        setSuccessVisible={setSuccessVisible}
        setVisible={setReviewVisible}
        onSubmitReview={onSubmitReview}
      />
    </section>
  );
};

/**评论详情 */
export const ReviewDetail = ({
  review,
  setCurrentReview,
  onPreview,
  visible,
  setVisible,
  onDelete = () => {},
  onEdit = () => {},
  reviews,
  setReviews,
  openReply = false,
}) => {
  const { t } = useTranslation();
  const { restaurantStore } = useStores();
  const [replies, setReplies] = useState([]);
  const [isReply, setIsReply] = useState(false);
  const [replyDes, setReplyDes] = useState("");
  const comment = { ...review };
  comment.photos = [];
  useEffect(() => {
    setIsReply(openReply);
  }, [openReply]);
  useEffect(() => {
    if (!review.id) return;
    restaurantStore.getReplies(review.id).then(setReplies);
  }, [review.id]);
  const onReply = () => {
    setIsReply(true);
  };
  // 回复评论
  const submitReply = () => {
    restaurantStore.saveReply(review.id, replyDes).then((res) => {
      restaurantStore.getReplies(review.id).then((data) => {
        setReplies(data);
        setIsReply(false);
        // 更新回复计数
        setCurrentReview({
          ...review,
          replies_count: data.length,
        });
        if (setReviews) {
          const list = JSON.parse(JSON.stringify(reviews));
          const index = list.findIndex((_) => _.id === review.id);
          list[index].replies_count = data.length;
          console.log("list[index].replies_count", list[index].replies_count);
          setReviews(list);
        }
      });
    });
  };
  return (
    <Drawer
      className="restaurant-drawer reviews-drawer"
      placement="right"
      closable={false}
      destroyOnClose
      onClose={() => setVisible(false)}
      visible={visible}
    >
      <Header title={t("Details")} onClick={() => setVisible(false)} />
      <ReviewItem
        review={review}
        reviews={reviews}
        setReviews={setReviews}
        setCurrentReview={setCurrentReview}
        onPreview={onPreview}
        showRateDetail={true}
        isShowGallery={true}
        mobile={true}
        showAll={true}
        onDelete={onDelete}
        onEdit={onEdit}
        onReply={onReply}
      />
      <div hidden={!replies.length}>
        <h3>{t("WEB.comments", { count: replies.length })}</h3>
        <div className="review-comments">
          {replies.map((item) => {
            return (
              <ReviewItem
                mobile={true}
                showAll={true}
                key={item.id}
                review={item}
              />
            );
          })}
        </div>
      </div>
      {isReply && (
        <div className="review-reply">
          <Input
            size="large"
            onChange={(e) => {
              setReplyDes(e.target.value);
            }}
            autoFocus
            placeholder={t("REVIEW.Describe placeholder")}
          />
          <Button size="small" type="primary" onClick={submitReply}>
            {t("REVIEW.Submit")}
          </Button>
        </div>
      )}
    </Drawer>
  );
};

export const ReviewItem = ({
  review,
  setReviews,
  setCurrentReview,
  onPreview,
  onClick,
  onReply,
  showRateDetail,
  showAll,
  mobile,
  isShowGallery = false,
  footer = true,
  onDelete,
  onEdit,
  member,
  hideMore = false,
  replies,
}) => {
  const { t } = useTranslation();
  const { reviewStore, memberStore } = useStores();
  const format = getQuery().lang == "en" ? "MMMMDD, YYYY" : "LL";
  // const date = moment(review.created_at).format(format);
  const date = review.i18n_created_at
    ? review.i18n_created_at
    : moment(review.created_at).format(format);
  const { avatar_url, level, level_icon, level_text } =
    review.member || review.owner || {};
  const {
    photos = [],
    rating_atmosphere,
    rating_cuisine,
    rating_service,
  } = review;
  const [show, setShow] = useState(false);
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);
  const [curReview, setCurReview] = useState(review);
  const [isMyReview, setIsMyReview] = useState(false);
  function showPhotos(index) {
    if (isShowGallery) {
      setActivePhotoIndex(index);
      setShow(true);
    }
  }
  const span = mobile ? { span: 8 } : { span: 8, md: 4, sm: 8 };
  const avg = useMemo(() => {
    return (rating_atmosphere + rating_cuisine + rating_service) / 3 / 2;
  }, [curReview]);
  const name = useMemo(() => {
    return curReview.name_reviewer || curReview.name;
  }, [curReview]);
  const content = useMemo(() => {
    return curReview.review_text || curReview.content;
  }, [curReview]);
  const photoList = useMemo(() => {
    return showAll ? photos : photos.slice(0, 6);
  }, [curReview]);

  useEffect(() => {
    setIsMyReview((member || memberStore.member)?.id === curReview?.member?.id);
  }, [member, curReview]);

  const menuRef = useRef(null);
  const [listening, setListening] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const toggleActionsVisble = () => setIsOpen(!isOpen);

  useEffect(
    listenForOutsideClicks(listening, setListening, menuRef, setIsOpen)
  );

  useEffect(() => {
    if (replies) {
      setCurReview({
        ...curReview,
        replies_count: replies.length,
      });
    }
  }, [replies]);

  useEffect(() => {
    setCurReview({
      ...review,
    });
  }, [review]);

  const setLike = () => {
    if (setLiking) {
      return;
    }
    setLiking = true;
    reviewStore
      .setReviewLike(curReview.id)
      .then((res) => {
        if (res.status) {
          let data = res.liked
            ? {
                ...curReview,
                liked: res.liked,
                upvotes: curReview.upvotes + 1,
              }
            : {
                ...curReview,
                liked: res.liked,
                upvotes: curReview.upvotes <= 0 ? 0 : curReview.upvotes - 1,
              };
          setCurrentReview(data);
          setReviews((list) => {
            return list.map((item) => {
              if (item.id === data.id) {
                return data;
              }
              return item;
            });
          });
        }
      })
      .finally(() => {
        setLiking = false;
      });
  };

  const deleteConfirm = () => {
    Modal.confirm({
      content: t("REVIEW.Cancel confirm"),
      onOk: () => {
        reviewStore.deleteReview(curReview.id).then((res) => {
          if (res.status) {
            onDelete && onDelete(curReview.id);
          }
        });
      },
      zIndex: 9999,
    });
  };

  const editConfirm = () => {
    onEdit && onEdit(curReview);
  };

  const handleReply = () => {
    if (onReply) {
      onReply(review);
    }
  };

  return (
    <div className="review-item" onClick={onClick} ref={menuRef}>
      <div className="review-avatar">
        <div className="review-avatar-pic">
          <img src={avatar_url + "-thumb"} alt="" />
        </div>
        {!!level && (
          <React.Fragment>
            {review?.owner_type !== "restaurant" && (
              <div className="review-level">
                <i className={"icon icon-" + level}></i>
              </div>
            )}
            {review?.owner_type === "restaurant" && (
              <div className="review-avatar-pic-icon">
                <img src={level_icon} alt="" />
                <p>{t("WEB.offical")}</p>
              </div>
            )}
            {review?.owner_type !== "restaurant" && (
              <div className="review-levelname small">
                {t(`LEVELS.${level}`)}
              </div>
            )}
          </React.Fragment>
        )}
      </div>
      <div className="review-info">
        <div className="review-author">{name || t("RESTAURANT")}</div>
        <time className="review-date">
          <span className="small">{date}</span>
        </time>
        <div className="review-tag" hidden={!curReview.verified}>
          <i className="icon icon-verified"></i>
          <span className="small">{t("WEB.Verified")}</span>
        </div>
        {/* 评分 */}
        <div className="review-rate" data-detail={showRateDetail}>
          {parseInt(avg) !== 0 && (
            <Rate count={5} value={avg} disabled style={{ fontSize: 12 }} />
          )}
          <div className="review-rate-detail" hidden={!showRateDetail}>
            <div className="rate-item">
              <div className="rate-item-label">{t("WEB.Food")}</div>
              <div className="rate-item-value">{padRight(rating_cuisine)}</div>
            </div>
            <div className="rate-item">
              <div className="rate-item-label">{t("WEB.Service")}</div>
              <div className="rate-item-value">{padRight(rating_service)}</div>
            </div>
            <div className="rate-item">
              <div className="rate-item-label">{t("WEB.Decor")}</div>
              <div className="rate-item-value">
                {padRight(rating_atmosphere)}
              </div>
            </div>
          </div>
        </div>

        {/* 评论 */}
        {showAll ? (
          <div className="review-desc">
            <div>{content}</div>
          </div>
        ) : (
          <div className="review-desc">
            <Typography.Paragraph ellipsis={{ rows: 2 }}>
              {content}
            </Typography.Paragraph>
            <div className="pc-text">{content}</div>
          </div>
        )}
        {show && (
          <Gallery
            onClose={() => setShow(false)}
            photos={photos}
            author={curReview.member?.nickname}
            date={date}
            activePhotoIndex={activePhotoIndex}
          ></Gallery>
        )}
        {/* 配图 */}
        <div className="review-pics">
          <Row gutter={6} justify="start">
            {photoList.map((item, index) => {
              return (
                <Col key={index} {...span}>
                  <div className="review-pic" onClick={() => showPhotos(index)}>
                    <img
                      alt=""
                      src={slimImage(item.image_url + "-thumb", "/w/180/h/124")}
                      onClick={() => onPreview(index, photos)}
                    />
                    {item.dish || item.comment ? (
                      <div className="small-icons">
                        {!!item.dish?.id && <i className="icon icon-menu"></i>}
                        {!!item.comment && <i className="icon icon-review"></i>}
                      </div>
                    ) : null}
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
        {/* 操作 */}
        {footer && (
          <div className="review-actions" onClick={(e) => e.stopPropagation()}>
            <Icon
              icon="icon icon-review-grey"
              text={curReview.replies_count || 0}
              onClick={() => handleReply()}
            />
            <Icon
              icon={`icon icon-small-heart ${
                curReview.liked ? "selected" : ""
              }`}
              text={curReview.upvotes || 0}
              onClick={() => setLike()}
            />
            {isMyReview && !hideMore && (
              <Icon icon="icon icon-more" onClick={toggleActionsVisble} />
            )}
            {isOpen && (
              <div className="more-actions">
                <div onClick={() => deleteConfirm()}>
                  <i className="icon icon-trash"></i> {t("REVIEW.Delete")}
                </div>
                <div onClick={() => editConfirm()}>
                  <i className="icon icon-edit"></i> {t("REVIEW.Edit")}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

function listenForOutsideClicks(listening, setListening, menuRef, setIsOpen) {
  return () => {
    if (listening) return;
    if (!menuRef.current) return;
    setListening(true);
    [`click`, `touchstart`].forEach((type) => {
      document.addEventListener(`click`, (evt) => {
        const cur = menuRef.current;
        const node = evt.target;
        if (cur?.contains(node)) return;
        setIsOpen(false);
      });
    });
  };
}
